import {
  Button,
  Heading,
  HStack,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Stack,
  StackDirection,
  Text,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import { useGoogleLogin } from "@react-oauth/google";
import { textLogo as logo } from "assets/images";
import { TouchableOpacity } from "components";
import { CopyRightText, MobileLinks } from "components/views";
import { useFormik } from "formik";
// import { jwtDecode } from "jwt-decode";
import { useTranslation } from "languages";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppLinks } from "tools/navigations";
import { useAppDispatch } from "tools/store";
import { ShowToast } from "utils/Helpers";
import * as Yup from "yup";
import {
  useCreateRegisterMutation,
  useCreateSessionMutation,
} from "../service";
import { setSession } from "../slice";
import { ResponseInterface, SessionCreateInterface } from "../types";

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const [showPassword] = useState(false);
  const [isGoogleLogin, setGoogleLogin] = useState(false);
  const [onCreateSession, { isLoading }] = useCreateSessionMutation();
  const [onCreateRegister, { isLoading: isRegistering }] =
    useCreateRegisterMutation();
  const translation = useTranslation();
  const toast = useToast();
  const dispatch = useAppDispatch();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("invalidEmailAddress")
      .required(translation["emailIsRequired"]),
    password: Yup.string().required(translation["passwordIsRequired"]),
  });

  const onUserSuccess = (data: any) => {
    navigate(AppLinks.DASHBOARD);
    ShowToast(toast, translation["login_success"], "success");
    dispatch(setSession(data));
  };

  const onUserVerification = (email: string) => {
    navigate(AppLinks.VERIFYOTP, { state: email });
    ShowToast(toast, translation["otpVerficationReq"], "warning");
  };

  const handleLogin = async (values: any, passs?: boolean) => {
    const response: ResponseInterface<SessionCreateInterface> =
      await onCreateSession(values);
    if (!response.error && response.data) {
      if (response.data.message === "OTP required for verification") {
        onUserVerification(values?.email);
      } else {
        onUserSuccess(response.data);
      }
    } else {
      if (response?.error?.data?.message === "User not found" && passs) {
        const resgisterRes: ResponseInterface<SessionCreateInterface> =
          await onCreateRegister(values);
        if (resgisterRes.data?.user) {
          onUserVerification(values?.email);
        }
      } else ShowToast(toast, translation["someThing"], "error");
    }
  };

  const { handleBlur, handleChange, values, handleSubmit, errors, touched } =
    useFormik({
      initialValues: {
        email: "",
        password: "",
      },
      validationSchema,
      onSubmit: (val) => handleLogin(val),
    });

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse);
      try {
        const { access_token, token_type } = tokenResponse;

        const response = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            method: "GET",
            headers: {
              Authorization: `${token_type} ${access_token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }

        const userInfo = await response.json();
        console.log("User Info:", userInfo);

        const data = {
          email: userInfo?.email,
          full_name: userInfo?.given_name,
          last_name: userInfo?.family_name,
          loginType: "1",
          password: "123456",
          confirm_password: "123456",
        };
        handleLogin(data, true);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
      setGoogleLogin(false);
    },
    onError: (error) => {
      console.log("=-=-=-=", error);
      setGoogleLogin(false);
    },
  });

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });
  const formWidth = useBreakpointValue({ base: "100%", md: "35%" });
  const paddingRight = useBreakpointValue({ base: "0", md: "180px" });

  return (
    <Stack
      direction={layoutDirection as StackDirection}
      w="full"
      h="100%"
      bgGradient="linear(to-r, transparent, secondary.950 40%)"
      paddingRight={paddingRight}
      overflow={"auto"}
      style={{ scrollbarWidth: "none" }}
      // pb={200}
    >
      {/* {imageWidth === "65%" && (
        <Image src={mobileBoard} objectFit="contain" w={imageWidth} />
      )} */}

      {layoutDirection === "row" && <MobileLinks />}

      <Stack
        w={formWidth}
        align="center"
        justify="center"
        spacing={[2, 4]}
        px={4}
        pos="relative"
      >
        <Image
          src={logo}
          w="50%"
          h="30%"
          objectFit="contain"
          mb="30px"
          mt={[12, 0]}
        />

        <Heading size="xl" textAlign="center" mb="10px">
          {translation["login_to_continue"]}
        </Heading>
        <InputGroup>
          <InputLeftElement pointerEvents="none" h="100%">
            {/* Add your SVG here */}
          </InputLeftElement>
          <Input
            type="text"
            name="email"
            placeholder={translation["your_email"]}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
            borderRadius={10}
            isInvalid={touched.email && Boolean(errors.email)}
            errorBorderColor="crimson"
          />
        </InputGroup>
        <InputGroup>
          <InputLeftElement pointerEvents="none" h="100%">
            {/* Add your SVG here */}
          </InputLeftElement>
          <Input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder={translation["password"]}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
            borderRadius={10}
            isInvalid={touched.password && Boolean(errors.password)}
            errorBorderColor="crimson"
          />
        </InputGroup>
        <Button
          w="100%"
          onClick={() => {
            handleSubmit();
          }}
          isLoading={isLoading || isRegistering}
          disabled={isLoading || isRegistering}
        >
          {translation["sign_in"]}
        </Button>

        <Button
          w="100%"
          variant={"outline"}
          onClick={() => {
            // setGoogleLogin(true);
            handleGoogleLogin();
          }}
          isLoading={isLoading || isRegistering || isGoogleLogin}
          disabled={isLoading || isRegistering || isGoogleLogin}
        >
          <HStack gap={5}>
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_2_18472)">
                <path
                  d="M7.62409 0.603031C4.94456 1.52084 2.65905 3.52877 1.39019 6.06049C0.94675 6.93534 0.626203 7.86518 0.435422 8.82639C-0.0509842 11.2163 0.287609 13.7605 1.39019 15.9407C2.10476 17.3634 3.13343 18.6263 4.3778 19.612C5.55429 20.5483 6.92156 21.2383 8.37562 21.6264C10.2052 22.1192 12.1577 22.1067 14.0054 21.6878C15.6747 21.3058 17.2517 20.5053 18.5081 19.3473C19.8384 18.1214 20.7871 16.5139 21.2925 14.7831C21.8407 12.8921 21.9146 10.8777 21.5696 8.9437C18.1201 8.9437 14.6705 8.9437 11.215 8.9437C11.215 10.3728 11.215 11.808 11.215 13.2371C13.2109 13.2371 15.2128 13.2371 17.2083 13.2371C16.9741 14.6108 16.1611 15.8612 15.0031 16.6372C14.2761 17.1237 13.4446 17.4442 12.5823 17.592C11.7139 17.7398 10.8205 17.7583 9.95816 17.586C9.0773 17.4137 8.23941 17.0437 7.50679 16.5264C6.33632 15.707 5.44343 14.5 4.98753 13.1508C4.5196 11.7771 4.51316 10.2435 4.98753 8.86979C5.31409 7.90256 5.86238 7.00323 6.58296 6.27663C7.46984 5.36483 8.62183 4.71815 9.8662 4.45346C10.9318 4.22573 12.0529 4.2687 13.094 4.5828C13.9809 4.85393 14.7943 5.33432 15.4655 5.97498C16.1431 5.30338 16.8142 4.6262 17.4919 3.95459C17.8429 3.59108 18.2189 3.24604 18.5635 2.87049C17.5409 1.92174 16.3339 1.15819 15.0216 0.677797C12.6686 -0.203922 10.0016 -0.222398 7.62409 0.603031Z"
                  fill="white"
                />
                <path
                  d="M7.62395 0.602848C10.0014 -0.222582 12.6689 -0.204105 15.0339 0.670738C16.3457 1.15113 17.5471 1.91511 18.5758 2.86343C18.2308 3.23296 17.8612 3.58402 17.5042 3.94754C16.8266 4.61914 16.1554 5.29632 15.4778 5.96793C14.8062 5.32726 13.9932 4.84086 13.1063 4.57574C12.0652 4.26164 10.9441 4.21867 9.87852 4.4464C8.63414 4.71109 7.48258 5.36421 6.59527 6.26957C5.87469 6.9966 5.32641 7.89593 4.99984 8.86273C3.79887 7.93246 2.59746 6.99617 1.39648 6.06632C2.65891 3.52859 4.94441 1.52066 7.62395 0.602848Z"
                  fill="#D60000"
                />
                <path
                  d="M0.435422 8.8262C0.626203 7.86542 0.952766 6.93515 1.39019 6.0603C2.59116 6.99058 3.79257 7.92687 4.99355 8.85671C4.51917 10.2304 4.52562 11.764 4.99355 13.1377C3.79257 14.068 2.59116 15.0042 1.39019 15.9341C0.287609 13.7663 -0.0509842 11.2161 0.435422 8.8262Z"
                  fill="#EE9500"
                />
                <path
                  d="M11.2207 8.93701C14.6702 8.93701 18.1197 8.93701 21.5753 8.93701C21.9203 10.871 21.8464 12.8854 21.2981 14.7765C20.7932 16.5072 19.8445 18.1212 18.5137 19.3406C17.3497 18.4353 16.1793 17.5295 15.0212 16.6241C16.1793 15.8541 16.9922 14.5977 17.2264 13.224C15.2305 13.224 13.2286 13.224 11.2331 13.224C11.2146 11.8013 11.2207 10.3722 11.2207 8.93701Z"
                  fill="#5057F5"
                />
                <path
                  d="M1.39062 15.9406C2.5916 15.0103 3.79301 14.074 4.99398 13.1442C5.44988 14.4994 6.34277 15.7004 7.51324 16.5198C8.24629 17.0371 9.08375 17.4006 9.96461 17.5794C10.827 17.7517 11.7263 17.7332 12.5887 17.5854C13.4511 17.4376 14.2825 17.1175 15.0096 16.6307C16.1736 17.536 17.3441 18.4418 18.5021 19.3471C17.2457 20.5112 15.6687 21.3061 13.9994 21.6876C12.1577 22.1066 10.2048 22.1186 8.36961 21.6262C6.91598 21.2382 5.54828 20.5481 4.3718 19.6118C3.13387 18.6201 2.1052 17.3573 1.39062 15.9406Z"
                  fill="#1F7300"
                />
              </g>
              <defs>
                <clipPath id="clip0_2_18472">
                  <rect width="22" height="22" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Text>Login with Google</Text>
          </HStack>
        </Button>

        {/* <GoogleLogin
          width="100%"
          onSuccess={async (credentialResponse) => {
            const { credential } = credentialResponse;
            try {
              const decodedUser: any = jwtDecode(credential || "");
              const data = {
                email: decodedUser?.email,
                full_name: decodedUser?.given_name,
                last_name: decodedUser?.family_name,
                loginType: "1",
                password: "123456",
                confirm_password: "123456",
              };
              handleLogin(data, true);
            } catch (error) {
              console.error("Error fetching user info: ", error);
            }
          }}
          onError={() => {
            console.log("Login Failed");
          }}
          useOneTap
        /> */}

        <Stack
          direction={layoutDirection as StackDirection}
          justify={"space-between"}
          w={"100%"}
          mt={2}
        >
          <Link
            alignSelf={"flex-start"}
            mt={1}
            href="http://qapp.thesoftwarestudios.com/initiate-password-reset"
            isExternal
          >
            <Text as={"u"} fontWeight={"medium"}>
              {translation["forget_password"]}
            </Text>
          </Link>
          {/* <HStack>
            <Text>{translation["dont_have_a_account"]}</Text>
            <TouchableOpacity onClick={() => navigate(AppLinks.REGISTER)}>
              <Text color="primary.300" fontWeight={"bold"}>
                {translation["register"]}
              </Text>
            </TouchableOpacity>
          </HStack> */}
          <Text>
            {translation["dont_have_a_account"]}{" "}
            <Link color="primary.300" href={AppLinks.REGISTER}>
              {translation["register"]}
            </Link>
          </Text>
        </Stack>

        <TouchableOpacity
          onClick={() => navigate(AppLinks.DASHBOARD)}
          alignSelf="flex-start"
        >
          <Text color="primary.300" fontWeight="bold" as="u">
            {translation["skip"]}
          </Text>
        </TouchableOpacity>
        <CopyRightText />
      </Stack>
    </Stack>
  );
};

export default SignIn;
